export default __webpack_public_path__ + "static/ASLA_Aptos_3-981c27732ec09c8b5073f5a43b6bcb6c.png";